const LOCAL_UPLOAD_URL = '/file/upload-local'
const PRODUCTION_CLOUD_UPLOAD_URL = LOCAL_UPLOAD_URL
const DEVELOPMENT_CLOUD_UPLOAD_URL = LOCAL_UPLOAD_URL

export const CLOUD_UPLOAD_URL = process.env.VUE_APP_CLOUD_UPLOAD_URL || (process.env.NODE_ENV === 'development' ? DEVELOPMENT_CLOUD_UPLOAD_URL : PRODUCTION_CLOUD_UPLOAD_URL)

export function extractCloudUploadUrl(response) {
  if (!response) return ''
  if (typeof response === 'string') return response

  const candidates = [
    response.url,
    response.imageUrl,
    response.fileUrl,
    response.data,
    response.data && response.data.url,
    response.data && response.data.imageUrl,
    response.data && response.data.fileUrl,
    response.data && response.data.path,
    response.data && response.data.localPath,
    response.data && response.data.data,
    response.result,
    response.result && response.result.url,
    response.result && response.result.imageUrl
  ]

  const value = candidates.find(item => typeof item === 'string' && item.trim())
  return value ? value.trim() : ''
}

export function isCloudUploadSuccess(response) {
  if (!response) return false
  if (extractCloudUploadUrl(response)) return true
  if (response.code === 200 || response.code === 0 || response.success === true) return true
  return false
}
